// "Market → Price forecast". Picked up by the glob in src/i18n/local/index.ts.
export default {
  nav_market_price_forecast: 'Price forecast',
  ak_nav_price_forecast: 'Price forecast',
  pf_title: 'DAM price forecast',
  pf_tab_day: 'Day',
  pf_tab_week: 'Week',
  pf_tab_year: 'Year (budget)',
  pf_prev_day: 'Previous day',
  pf_next_day: 'Next day',
  pf_hourly: 'Hourly forecast for {{date}}',
  pf_horizon: 'horizon D+{{h}}',
  pf_horizon_col: 'Horizon',
  pf_no_forecast: 'No forecast for this day. Forecasts are stored from 23.10.2026; pick a later date.',
  pf_loading: 'Loading…',
  pf_load_error: 'Could not load the forecast.',
  pf_p50: 'Forecast 50 %',
  pf_corridor: 'Range 10–90 %',
  pf_p50_legend: 'Forecast with 50 % probability',
  pf_corridor_legend: 'Likely price range 10–90 %',
  pf_actual: 'DAM actual',
  pf_last_year: 'Actual last year',
  pf_uah_mwh: 'UAH/MWh',
  pf_uah: 'UAH',
  pf_mwh: 'MWh',
  pf_k_uah: 'k UAH',
  pf_bess_title: 'BESS cycle by forecast',
  pf_bess_sub: 'Luchky BESS: buy {{buy}} MWh, sell {{sell}} MWh — round-trip efficiency {{eff}} % (SOC 18–99 %, charge ×1.15, discharge ÷1.05, PCS 16 MW, charge before discharge)',
  pf_charge: 'Charge',
  pf_discharge: 'Discharge',
  pf_price_axis: 'Price forecast',
  pf_expected: 'Expected result',
  pf_realized: 'At actual prices',
  pf_ideal: 'Ideal cycle',
  pf_naive_plan: '"Same as yesterday" plan',
  pf_shortfall: 'Shortfall vs ideal',
  pf_bess_no_cycle: 'By the forecast the spread does not cover cycle losses — charging and discharging does not pay.',
  pf_bess_wait: 'Actuals are not published yet — the result at actual prices appears after the exchange publishes (the day before at about 13:00).',
  pf_acc_title: 'Price forecast accuracy',
  pf_acc_rule: 'An accurate hour has an error of at most {{rel}} % of the actual, or at most {{abs}} UAH where that is larger',
  pf_acc_hours: 'Accurate hours',
  pf_of: '{{a}} of {{b}}',
  pf_mae: 'Mean error',
  pf_bias: 'Bias',
  pf_bias_hint: 'positive — forecast above actual',
  pf_in_corridor: 'Actual within band',
  pf_error: 'Error (forecast − actual)',
  pf_accurate: 'Accurate',
  pf_inaccurate: 'Inaccurate',
  pf_acc_wait: 'Actuals for this day are not published yet — the exchange publishes results the day before at about 13:00.',
  pf_week_title: 'Week ahead',
  pf_date: 'Date',
  pf_avg: 'Average',
  pf_minmax: 'Min – max',
  pf_cheap: 'Cheapest',
  pf_dear: 'Most expensive',
  pf_year_title: 'Annual forecast by month',
  pf_year_note: 'Budget forecast: the typical daily shape of the same month last year × the level with the trend of the last 90 days. Nobody forecasts a specific hour months ahead — this is a level and a band, not a promise.',
  pf_month: 'Month',
  pf_trend: 'trend ×{{t}}',
  pf_quality_title: 'Model quality on history',
  pf_quality_sub: 'Backtest over {{days}} days: each forecast uses only data known at submission time and is compared with the naive "same hour on the last known day". Green means the model beats the naive forecast.',
  pf_model: 'Model',
  pf_naive: 'Naive',
  pf_bess_90: 'BESS over {{days}} days, % of ideal',
  pf_band: 'Band: coverage · width',
  pf_quality_note: 'How to read: the BESS cycle has almost the same shape every day (cheap midday, expensive evening), so even the naive forecast captures 90 %+ of the ideal. What matters is the difference from naive in UAH, not the share itself. Band coverage means nothing without its width: a wide band covers anything.',
  pf_old_run: 'The metrics of this run use the old method; they will update with the next run.',
} as Record<string, string>;
